export const GET_WISH_LIST = 'GET_WISH_LIST';
export const UPDATE_WISH_LIST = 'UPDATE_WISH_LIST';
export const ADD_ITEM_TO_LIST = 'ADD_ITEM_TO_LIST';
export const REMOVE_ITEM_FROM_LIST = 'REMOVE_ITEM_FROM_LIST';

export default {
    GET_WISH_LIST,
    UPDATE_WISH_LIST,
    ADD_ITEM_TO_LIST,
    REMOVE_ITEM_FROM_LIST,
};



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/add-to-wishlist/mutations.js